<template>
  <div>
    <Row>
      <Input v-model="search" placeholder="Search..." style="width: 300px"/>
      <Button @click="startAddingCompany" style="float: right; margin-bottom: 5px;">Add Company</Button>
    </Row>
    <Row>
      <ApolloQuery :query="query_GET_COMPANIES" :variables="{searchFilter: searchFilter}" :debounce="500">
        <ApolloSubscribeToMore :document="subscription_SUBSCRIBE_COMPANIES" :debounce="500" :variables="{searchFilter: searchFilter}"
                               :update-query="onUpdateCompany"></ApolloSubscribeToMore>
        <template slot-scope="{ result: { loading, error, data } }">
          <div v-if="loading">
            <Spin fix size="large"></Spin>
          </div>
          <div v-else-if="error"> Error Occured. {{error}}</div>
          <div v-else-if="data">
            <Table :columns="headers" :data="data.company" @on-row-click="openCompanyDetail" stripe>
              <template slot-scope="{ row }" slot="firstAddressCity">
                <span>{{row.address[0].city}}</span>
              </template>
              <template slot-scope="{ row }" slot="gstin">
                <span style="text-transform: uppercase">{{row.gstin}}</span>
              </template>
              <template slot-scope="{ row }" slot="firstAddress">
                <span v-if="row.address[0].add1">{{row.address[0].add1}}, </span>
                <span v-if="row.address[0].add2">{{row.address[0].add2}}, </span>
                {{row.address[0].area}}, {{row.address[0].city}},<br>{{row.address[0].state}} - {{row.address[0].pincode}}
              </template>
              <template slot-scope="{ row }" slot="action">
                <Icon type="md-create" @click.stop="onEditCompany(row)"></Icon>
              </template>
            </Table>
          </div>
          <div v-else>
            <Spin fix size="large"></Spin>
          </div>
        </template>
      </ApolloQuery>
    </Row>

    <company-drawer ref="register-company-form"></company-drawer>
    <company-detail ref="company-detail-page"></company-detail>
    <edit-company-drawer ref="edit-company-form"></edit-company-drawer>

  </div>
</template>

<script>
  import CompanyDrawer from './RegisterCompanyDrawer'
  import EditCompanyDrawer from './EditCompanyDrawer'
  import { GET_COMPANIES } from '../graphql/queries/companies'
  import { SUBSCRIBE_COMPANIES } from '../graphql/subscription/companies'
  import CompanyDetail from './CompanyDetail'

  export default {
    name: 'Companies',
    components: { CompanyDetail, CompanyDrawer, EditCompanyDrawer },
    data () {
      return {
        query_GET_COMPANIES: GET_COMPANIES,
        subscription_SUBSCRIBE_COMPANIES: SUBSCRIBE_COMPANIES,
        editCompanyDrawer: false,      //when add company
        companyDetailDrawer: false,
        companyId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
        headers: [
          { title: 'City', slot: 'firstAddressCity', width:100},
          { title: 'Name', key: 'name'},
          { title: 'Mobile', key: 'mobile', width:150},
          { title: 'Email', key: 'email' },
          { title: 'GSTIN', slot: 'gstin' },
          { title: 'Address', slot: 'firstAddress' },
          { title: 'Action', slot: 'action', width:90 },
        ],
        companyType: [],
        addToAddressBookOnly: false,
        search: '',
        updateCompanyDrawer: false       //when edit company
      }
    },
    computed: {
        searchFilter () {
            return '%' + this.search + '%'
        }
    },
    methods: {
      openCompanyDetail (rowData, rowindex) {
        this.companyId = rowData.id
        this.$refs['company-detail-page'].skip = false
        this.companyDetailDrawer = true
      },
      startAddingCompany () {
        this.$refs['register-company-form'].companyType_skip = false;
        this.editCompanyDrawer = true
      },
      onEditCompany (row) {
        this.$refs['edit-company-form'].companyType_skip = false;
        this.$refs['edit-company-form'].setCompanyForm(row);
        this.updateCompanyDrawer = true
      },
      onUpdateCompany (previousResult, { subscriptionData }) {
        if (!subscriptionData.data.company) return
        if (previousResult) {
          return {
            company: [...subscriptionData.data.company]
          }
        }
      }
    }
  }
</script>

<style scoped>
  .ivu-table-wrapper, .ivu-table, .ivu-table-body {
    cursor: pointer !important;
  }

</style>
